import { loading, success, error } from 'State/actions';
import { ManageProcessOrderEnum } from 'Common/FieldEnum';

import * as types from './types';

export const manageProcessOrders = orderListArray => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PROCESS_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Order/ProcessOrCloseOrder/false`,
        orderListArray
      );
      const processObject = response.data.Data;
      if (processObject && processObject[ManageProcessOrderEnum.ProcessId]) {
        dispatch(
          success(
            types.SET_PROCESS_ID,
            processObject[ManageProcessOrderEnum.ProcessId]
          )
        );
      } else if (
        processObject &&
        processObject[ManageProcessOrderEnum.Message]
      ) {
        dispatch(success(types.SET_PROCESS_ID, ''));
        dispatch(
          success(types.SET_PROCESS_MESSAGE_ERROR, {
            message: processObject[ManageProcessOrderEnum.Message],
            duplicateIds: processObject[ManageProcessOrderEnum.DuplicateIds],
          })
        );
      }
    } catch (err) {
      dispatch(error(types.PROCESS_ORDER_ERROR, err));
    }
    dispatch(loading(types.PROCESS_ORDER_LOADING, false));
  };
};
export const setProcessedOrderPreviewData = payload => {
  return {
    type: types.PROCESSED_ORDER_PREVIEW_DATA,
    payload,
  };
};

export const createPurchaseWarehouseBackOrders = (
  orderListArray,
  redirectToRootPage
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CREATE_PO_WO_BO_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        `Order/CreateOrder`,
        orderListArray
      );
    } catch (error) {
      dispatch({
        type: types.CREATE_PO_WO_BO__ERROR,
        payload: error,
      });
    } finally {
      dispatch(setProcessedOrderPreviewData([]));
      redirectToRootPage();
      dispatch(loading(types.CREATE_PO_WO_BO_LOADING, false));
    }
  };
};

export const getPreviewOrders = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_PREVIEW_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`Order/GetPreviewOrders`);
      dispatch(setProcessedOrderPreviewData(response.data.Data));
    } catch (error) {
      dispatch(error(types.PROCESS_ORDER_ERROR, error));
    } finally {
      dispatch(loading(types.FETCH_PREVIEW_ORDER_LOADING, false));
    }
  };
};

export const clearPreviewOrderError = () => {
  return {
    type: types.CLEAR_PREVIEW_ORDER_ERROR,
  };
};

export const getPrintPreviewData = sortBy => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_PREVIEW_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('Order/PrintOrder/' + sortBy);
      dispatch(success(types.PRINT_PREVIEW_DATA, response.data.Data));
    } catch (err) {
      dispatch(error(types.PRINT_PREVIEW_ERROR, err));
    } finally {
      dispatch(loading(types.PRINT_PREVIEW_LOADING, false));
    }
  };
};

export const getPrintVendorSummaryData = sortBy => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_VENDOR_SUMMARY_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        'Order/PrintVendorSummary/' + sortBy
      );
      dispatch(success(types.PRINT_VENDOR_SUMMARY_DATA, response.data.Data));
    } catch (err) {
      dispatch(error(types.PRINT_VENDOR_SUMMARY_ERROR, err));
    } finally {
      dispatch(loading(types.PRINT_VENDOR_SUMMARY_LOADING, false));
    }
  };
};
export const clearPrintVendorSummary = () => {
  return {
    type: types.CLEAR_PRINT_VENDOR_SUMMARY_DATA,
  };
};
export const clearPrintPreviewData = () => {
  return {
    type: types.CLEAR_PRINT_PREVIEW_DATA,
  };
};
export const clearProcessMessage = () => {
  return {
    type: types.CLEAR_PROCESS_MESSAGE,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/processOrder/actions.js